import { render, staticRenderFns } from "./VRAbouttheData.vue?vue&type=template&id=1a144aba"
import script from "./VRAbouttheData.vue?vue&type=script&lang=js"
export * from "./VRAbouttheData.vue?vue&type=script&lang=js"
import style0 from "./VRAbouttheData.vue?vue&type=style&index=0&id=1a144aba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports